// @core/api/endpoints/authn/list_sso_sessions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSSOSessionsResponse,
} from '../../../types/authn';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/authn';

/**
 * List SSO sessions for user
 * Returns a paginated list of active SSO sessions for the current user. Includes session metadata like creation time, IP address, and connected applications.
 */
export async function ListSSOSessions(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSSOSessionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/sso/sessions`;
  const requestOptions = options;
  return client.get<ListSSOSessionsResponse>(requestPath, { ...requestOptions, params });
}
